/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';

export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    payload: data,
  };
};

export const setCms64Data = (data) => {
  return {
    type: actionTypes.SET_CMS64_DATA,
    payload: data,
  };
};
export const setCms64ResearchData = (data) => {
  return {
    type: actionTypes.RSCH_CMS_QTR_REPORT,
    payload: data,
  };
};
export const setPaymentsData = (data) => {
  return {
    type: actionTypes.PAYMENTS_DATA,
    payload: data,
  };
};

export const setErrorMessagesData = (data) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES,
    payload: data,
  };
};
export const setCMSApiResponse = (data) => {
  return {
    type: actionTypes.CMS_API_RESPONE,
    payload: data,
  };
};

export const getRebateProgramCode = (values, signal) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      if (signal?.aborted) {
        return;
      }
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      if (signal?.aborted) {
        return;
      }
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};
export const dispatchDetailScreenObj = (data) => {
  return {
    type: actionTypes.SET_DETAIL_SCREEN,
    payload: data,
  };
};
export const dispatchRebateProgByCMSReportGrp = (data) => {
  return {
    type: actionTypes.REBATE_PRGBY_CMS,
    payload: data,
  };
};

export const getRebateProgramByCMSReportGrp = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.LIST_CMS_REBATE_PROGRAM, values)
    .then((response) => {
      return dispatch(dispatchRebateProgByCMSReportGrp(response.data));
    })
    .catch((response) => {
      dispatch(dispatchRebateProgByCMSReportGrp({ error: 'API failed' }));
    });
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.GET_MAXQUARTER_FOR_CMS_REPORT,
    payload: data,
  };
};
export const setCMSReportingGrps = (data) => {
  return {
    type: actionTypes.SET_CMS_REPORTING_GRPS,
    cmsReportingGrps: data,
  };
};
export const getMaxQuarterForRebatePrg = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CMS_RPT_MAX_QTR}`, value)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};
export const listCmsReportGroups = (values) => (dispatch) => {
    const queryParams = `invCUfile=true&quarter=${values}`;
  return axios
    .post(`${serviceEndPoint.LIST_UTIL_REPORT_GROUPS}?${queryParams}`)
    .then((response) => {
      return dispatch(setCMSReportingGrps(response.data));
    })
    .catch((response) => {
      dispatch(setCMSReportingGrps(response.date));
    });
};

export const dispatchReportQuarter = (data) => {
  return {
    type: actionTypes.CREATE_CORRECT_CMS_GET_REPORT_QUARTER,
    payload: data,
  };
};

export const updateReportQuarter = (data) => {
  return {
    type: actionTypes.UPDATE_CORRECT_CMS_GET_REPORT_QUARTER,
    payload: data,
  };
};

export const getReportQuarter = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.CREATE_CORRECT_CMS_GET_REPORT_QUARTER}`, values)
    .then((response) => {
      return dispatch(dispatchReportQuarter(response.data));
    })
    .catch((response) => {
      dispatch(dispatchReportQuarter(response.response.data));
    });
};

export const dispatchGetInvoiceStartQtr = (data) => ({
  type: actionTypes.INVOICE_START_QTR,
  invStartQtr: data,
});

export const getInvoiceStartQtr = (values, next) => {
  return axios
    .post(serviceEndPoint.INVOICE_START_QTR, values)
    .then((response) => {
      next(response.data);
    })
    .catch((res) => {
      next(res.response.data);
    });
};

export const dispatchGetPreviousQtr = (data) => ({
  type: actionTypes.GET_PREVIOUS_QTR,
  payload: data,
});
export const getPreviousQtr = (values) => (dispatch) => {
  return axios
    .post(
      serviceEndPoint.GET_PREVIOUS_QTR,
      {
        rptQtr: values,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then((response) => {
      let data = response.data;
      dispatch(dispatchGetPreviousQtr(data));
    })
    .catch(() => {
      dispatch(dispatchGetPreviousQtr(null));
    });
};

export const dispatchSaveCmsQtrReport = (data) => {
  return {
    type: actionTypes.SAVE_CMS_QTR_REPORT,
    payload: data,
  };
};

export const saveCmsQtrReport = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SAVE_CMS_QTR_REPORT}`, values)
    .then((response) => {
      return dispatch(dispatchSaveCmsQtrReport(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSaveCmsQtrReport(response.date));
    });
};

export const dispatchGetCreateCmsExtraState = (data) => ({
  type: actionTypes.CREATE_CMS_EXTRA_STATE,
  extraState: data,
});
export const setCreateCmsExtraState = (value) => (dispatch) => {
  dispatch(dispatchGetCreateCmsExtraState(value));
};
export const clearCreateCmsTab = (payload) => {
  return {
    type: actionTypes.CLEAR_CREATE_CMS_TAB,
  };
};
